<template>
<div class="item" @click="goDetails">
  <h4>{{title}}</h4>
  <div class="content">
    <div class="info">
      <span class="info-item">时间： {{getTimeStr()}}</span>
      <span class="info-item">地点： {{address}}</span>
      <span class="info-item">说明：{{getDesc}}</span>
    </div>
    <span class="icon iconfont">&#xe670;</span>
  </div>
  <div class="user">
    <div class="user-info">
      <!-- <img class="avater" v-if="user.avatar" v-lazy="user.avatar"/> -->
      <img class="avater" v-if="user.avatar" v-lazy="`${user.real_avatar!=='null' && user.real_avatar!=='' ? user.real_avatar:user.avatar}?x-oss-process=image/resize,m_fill,w_72,h_72`"/>
      <img class="avater" v-else src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/default-profile.png?x-oss-process=image/resize,m_fill,w_72,h_72"/>
      <div class="details">
        <!-- <span class="name">{{user.nickName}}</span> -->
        <span class="name">{{user.fullname !== '' && user.fullname !=='null' ? user.fullname : user.nickName}}</span>
        <!-- <h2 v-else>{{fullname !== '' && fullname !=='null' ? fullname : nickName}}</h2> -->
      </div>
    </div>
    <span class="time">{{getTimes()}}发起</span>
    <!-- <span class="autograph">{{user.signName || '太忙了，没来得及编写个性签名😄'}}</span> -->
  </div>
</div>
</template>
<script>
import { formateRegexToDate, formateDateTostr, getBeforeTimeStr } from '../utils/date'
export default {
  props: {
    address: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    },
    assembleTime: {
      type: String,
      default: ''
    },
    createTime: {
      type: String,
      default: ''
    },
    user: {
      type: Object,
      default: () => {
        return {
          avatar: '',
          id: 12,
          isForbidden: false,
          nickName: '',
          signName: '太忙了，没来得及编写个性签名😄',
          username: ''
        }
      }
    }
  },
  methods: {
    getTimes () {
      return getBeforeTimeStr(this.createTime)
    },
    getTimeStr () {
      return formateDateTostr(formateRegexToDate(this.assembleTime), 'MM月DD日 星期WEEK HH:mm')
    },
    goDetails () {
      this.$router.push({
        path: `/exerland/summoningOrderDetails/${this.id}`
      })
    }
  },
  computed: {
    getDesc () {
      const regex = /<br\/>/g
      const desc = this.desc.replace(regex, '')
      return desc
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/font/iconfont.css';
.item {
  box-sizing: border-box;
  width:100%;
  background:rgba(255,255,255,1);
  border-radius:8px;
  border:2px solid rgba(51,51,51,1);
  padding: 16px;
  margin-bottom: 16px;
  h4 {
    font-size:20px;
    font-family:PingFangSC-Semibold,PingFang SC;
    font-weight:600;
    color:rgba(0,0,0,1);
    line-height:28px;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;
    .info {
      width: 280px;
      .info-item {
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:17px;
        display: block;
        margin-bottom: 4px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .iconfont {
        width: 10.69px;
        height: 18px;
      }
    }
  }
  .user {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 18px;
    .user-info {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      .avater {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        margin-right: 6px;
      }
      .details {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .name {
          font-size:16px;
          font-family:PingFangSC-Semibold,PingFang SC;
          font-weight:600;
          color:rgba(51,51,51,1);
          line-height:16px;
        }
      }
    }
    .time {
          display: inline-block;
          font-size:11px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(60,60,67,0.6);
          line-height:12px;
        }
    .autograph {
      box-sizing: border-box;
      width:173px;
      height:36px;
      background:rgba(245,245,245,1);
      border-radius:4px;
      padding: 1px 6px;
      font-size:11px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(136,136,136,1);
      line-height:16px;
    }
  }
}
</style>
